
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Sidebar from '../../comman_page/Sidebar';
import { HeaderDashboard } from '../../comman_page/HeaderDashboard';
import { Footer } from '../../../../../public/containers/footer/Footer';
import { draftDiscountCodeDeleteAPI, getDiscountDraftByBusinessAPI } from '../../../../../Studio-Services/Studio_Services';

import moment from 'moment';
import DiscountApplyTo from './DiscountApplyTo';

const DiscountCodeDraftList = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [list, setList] = useState([]);
    const [show, setShow] = useState(false);
    const [codeData, setCodeData] = useState()


    const getListData = async () => {
        setLoader(true);
        try {
            const resp = await getDiscountDraftByBusinessAPI();
            if (resp?.status === 1) {
                const data = resp?.data || [];
                const sortedData = [...data].sort((a, b) => {
                    if (a.status === "Active" && b.status !== "Active") return -1;
                    if (a.status !== "Active" && b.status === "Active") return 1;
                    return 0;
                });

                setList(sortedData);
            }
        } catch (error) {
            console.log("error", error);

        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        getListData();
    }, [])

    const deleteHandler = async (id) => {

        // if (!id) return;
        // const payload = { 'id': id };

        // try {
        //     const resp = await draftDiscountCodeDeleteAPI(payload);
        // } catch (error) {

        // }

    }


    return (
        <>
            {loader && <div className="MainLoader"> <Spinner animation="border" /> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <HeaderDashboard />
                                <section className="addClient innerContent">
                                    <div className="AddClientContent">
                                        <Container className="mb-5 pb-4">
                                            <div className="d-flex justify-content-between mb-3">
                                                <h4>Marketing & Discount Codes</h4>
                                                <div>
                                                    <button
                                                        onClick={() => { navigate('/discount-code-list') }}
                                                        type="button"
                                                        className="btn btn-primary px-2 py-1 me-2" style={{ fontSize: '1rem' }}>
                                                        Published Codes
                                                    </button>
                                                    <button
                                                        onClick={() => { navigate('/discount-code') }}
                                                        type="button"
                                                        className="btn btn-primary px-2 py-1" style={{ fontSize: '1rem' }}>
                                                        Add Discount Code
                                                    </button>
                                                </div>
                                            </div>
                                            <p className="open-sans">
                                                Marketing tools allow you to create and manage promotional discount
                                                codes for passes and workshops. This premium feature lets you offer
                                                special pricing that clients can apply at checkout—online, in the
                                                mobile app, or when processed by an admin. Once activated, you can
                                                create, enable, or disable discount codes, control their usage, and
                                                encourage new purchases through targeted promotions.
                                            </p>
                                            <Row className="mt-5">
                                                <hr />

                                                <Col className="col-12">
                                                    <h4 style={{ fontWeight: '600' }}>Draft Discount Codes</h4>
                                                    <Row className="mt-3 ">
                                                        <Col className="col-12" style={{ overflow: 'auto' }}>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">#</th>
                                                                        <th scope="col">Discount code name</th>
                                                                        <th scope="col">Percent</th>
                                                                        <th scope="col">Promo Start date</th>
                                                                        <th scope="col" style={{ width: '170px' }}>Promo End Day</th>
                                                                        <th scope="col">Single use per client</th>
                                                                        <th scope="col">Apply to</th>
                                                                        <th scope="col">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {list?.length > 0 && list.map((item, index) => (
                                                                        <tr>
                                                                            <th scope="row">{index + 1}</th>
                                                                            <td>{item?.code_name}</td>
                                                                            <td>
                                                                                {item?.amount_type === "DOLLAR" && "$ "}
                                                                                {item?.amount}
                                                                                {item?.amount_type === "PERCENT" && " %"}
                                                                            </td>
                                                                            <td> {moment(item?.start_date).format("MMM DD YYYY")}</td>
                                                                            <td className='d-flex justify-content-between'>
                                                                                {moment(item?.end_date).format("MMM DD YYYY")}
                                                                            </td>
                                                                            <td className='text-center'>{item?.is_single_use}</td>
                                                                            <td className='text-center'>
                                                                                <div onClick={() => { setCodeData(item); setShow(true); }} style={{ cursor: 'pointer' }}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                                                                    </svg>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <span className='px-1 py-1' style={{ border: '1px solid black', borderRadius: 5, cursor: 'pointer' }}
                                                                                    onClick={() => { navigate('/discount-code-edit', { state: { item } }) }}
                                                                                >

                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                                                                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                                                                    </svg>
                                                                                </span>


                                                                                {/* <span className='px-1 py-1 ms-1' style={{ border: '1px solid black', borderRadius: 5, cursor: 'pointer' }}
                                                                                    onClick={() => { deleteHandler(item?.id) }}
                                                                                >

                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                                    </svg>
                                                                                </span> */}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >
            <DiscountApplyTo show={show} handleClose={() => setShow(false)} codeData={codeData} />
        </>
    )
}

export default DiscountCodeDraftList